module.exports = __webpack_public_path__ + "static/media/pledge_bg.d2397c55.png";